import { SearchFilterContentTypes } from 'search-gateway-client';

const DEFAULT_AI_PLACEHOLDER = "Describe what you need... and we'll find what fits...";

const AI_PLACEHOLDERS: Partial<Record<SearchFilterContentTypes, string>> = {
    [SearchFilterContentTypes.All_videos_content_type]: "Describe the scene you're looking for",
    [SearchFilterContentTypes.Footage]: "Describe the footage you're looking for",
    [SearchFilterContentTypes.Motion_bgs]: 'Describe the graphic you want',
    [SearchFilterContentTypes.Templates]: "Describe the template you're looking for",
};

export const getSearchWithAIPlaceholder = (
    defaultPlaceholder: string | undefined,
    contentType: SearchFilterContentTypes | undefined,
    conversationalSearchEnabled: boolean,
): string | undefined => {
    if (!conversationalSearchEnabled) {
        return defaultPlaceholder;
    }

    if (contentType === undefined) {
        return DEFAULT_AI_PLACEHOLDER;
    }

    return AI_PLACEHOLDERS[contentType] ?? DEFAULT_AI_PLACEHOLDER;
};
